import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Row, Col } from 'reactstrap';

import authorizedFetch from '../api-authorization/AuthorizedFetch';
import WithLoader from '../WithLoader';
import { PageSection } from '../PageSection';
import { Baseline } from '../shared/components';
import CheckInHistoryChart from '../CheckInHistoryChart';
import ResponseLabel from '../ResponseLabel';
import { safeParseResponse } from '../../utils';

const UserView = () => {
    const { id } = useParams();

    const [userViewData, setUserViewData] = useState({});

    const fetchData = async done => {
        const response = await authorizedFetch(`api/users/${id}`);
        const userData = await safeParseResponse(response) || {};
        setUserViewData(userData);
        done();
    };

    /* todo - should we remove these? they were commented
        const toggle = () => setStudentModalOpen(!studentModalOpen);
        const studentAdded = () => fetchData();
        const gotoCheckIn = e => history.push(`/check-ins/${e.target.value}/summary`);
    */

    const { 
        baseline, 
        checkInGraph, 
        classBaselines, 
        days, 
        daysDysregulated, 
        favoriteActivity, 
        name: userName 
    } = userViewData || {};

    return (
        <WithLoader action={fetchData}>
            {/* todo - does this var name make sense? */}
            <h3>{userName}</h3>
            <PageSection title="Individual Baseline">
                <Baseline value={baseline} disabled />
            </PageSection>
            <PageSection title="Historical Baseline">
                <CheckInHistoryChart data={checkInGraph} />
            </PageSection>
            <Row>
                <Col>
                    <PageSection title="Dysregulated Days">
                        {daysDysregulated}
                    </PageSection>
                </Col>
                <Col>
                    <PageSection title="Favorite Regulation Activity">
                        {favoriteActivity}
                    </PageSection>
                </Col>
            </Row>
            <PageSection title="Classes">
                <Table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Baseline Response</th>
                        </tr>
                    </thead>
                    <tbody>
                        {classBaselines?.map(({ name: nameOfClass, baseline }) =>
                            <tr>
                                <td>{nameOfClass}</td>
                                <td>
                                    <ResponseLabel response={baseline} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </PageSection>
            <PageSection title="Days of the Week">
                <Table>
                    <thead>
                        <tr>
                            <th>Day of the Week</th>
                            <th>Baseline Response</th>
                        </tr>
                    </thead>
                    <tbody>
                        {days?.map(({ name: dayName, baseline }) =>
                            <tr>
                                <td>{dayName}</td>
                                <td>
                                    <ResponseLabel response={baseline} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </PageSection>
        </WithLoader>
    );
}

export default UserView;